import { createApp, configureCompat } from 'vue';
import { createPinia } from 'pinia';
import './styles/reset.css'; // a modern alternative to CSS resets

import element from './element/index';
configureCompat({
  COMPONENT_V_MODEL: false,
  // Disable Vue 2 compatibility for v-model
  ATTR_FALSE_VALUE: false,
  COMPONENT_ASYNC: false,
  INSTANCE_LISTENERS: false,
  // 禁用 $listeners 兼容，现在 SvgIcon 已修复
  INSTANCE_ATTRS_CLASS_STYLE: false,
  // 禁用 class/style 在 $attrs 中的兼容
  TRANSITION_GROUP_ROOT: false,
  WATCH_ARRAY: false,
  RENDER_FUNCTION: false
});
import './styles/element-variables.scss';
import '@/styles/index.scss'; // global css
import permission from '@/directive/permission/permission';
import App from './App';
import store from './store';
import router from './router';
import './icons'; // icon
import './permission'; // permission control

import { format } from './utils/date-utils';
var app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(store);
app.use(element);
// app.use(ElementPlus, {
//   // 支持 large、default、small
//   size: 'default'
// })

// app.config.globalProperties.$ELEMENT = { size: 'mini' }
app.directive('permission', permission);

// Event bus replacement
import mitt from 'mitt';
var emitter = mitt();
var bus = {};
bus.$on = emitter.on;
bus.$emit = emitter.emit;
bus.$off = emitter.off;
app.config.globalProperties.$bus = bus;

// eslint-disable-next-line no-extend-native
Date.prototype.format = function (pattern) {
  return format(this, pattern);
};

// Handle ResizeObserver benign errors
// window.addEventListener('error', (event) => {
//   if (event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
//     event.preventDefault()
//     return false
//   }
//   return true
// })

app.mount('#app');